// ============================================================================
// page-service-single / value-benefit.js
// ----------------------------------------------------------------------------
// "Values and benefits" — paired Flickity sliders that stay in sync.
//
//   .service-value-banefit__slider          Image strip (center, wrap).
//   .service-value-banefit__body-wrapper    Title/description body (center, wrap).
//   .service-value-banefit__button.prev/.next   External arrows.
//
// Sync rules (mirror of the original inline JS):
//   - Image slider `change` → select the same index on the body slider.
//   - Prev / next buttons → step the BODY slider (not the image slider).
//   - If there are zero `.service-value-banefit__slider-item-image` items,
//     remove the image strip entirely; body slider still works.
//
// "banefit" misspelling is preserved on purpose — the CSS depends on it.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const imageStripEl = document.querySelector(".service-value-banefit__slider");
  const bodyStripEl = document.querySelector(
    ".service-value-banefit__body-wrapper",
  );
  if (!bodyStripEl) return;

  // Drop the image strip if it has no items, before initialising either.
  const imageEls = document.querySelectorAll(
    ".service-value-banefit__slider-item-image",
  );
  const hasImages = imageEls.length > 0;
  if (imageStripEl && !hasImages) imageStripEl.remove();

  // Body slider always inits.
  bodyStripEl.style.display = "block";
  const bodyInstances = initCarousels(".service-value-banefit__body-wrapper", {
    cellAlign: "center",
    contain: false,
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true,
  });
  if (!bodyInstances || !bodyInstances.length) return;
  const body = bodyInstances[0].flickity;

  // Image slider only inits if it stayed in the DOM (i.e. it has items).
  if (hasImages && imageStripEl) {
    imageStripEl.style.display = "block";
    const imageInstances = initCarousels(".service-value-banefit__slider", {
      cellAlign: "center",
      contain: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
    });
    if (imageInstances && imageInstances.length) {
      const image = imageInstances[0].flickity;
      // Image change → body follows. `select(index, isWrapped, isInstant)`
      // — match the original `(index, true, false)` (animated, with wrap).
      image.on("change", function (index) {
        body.select(index, true, false);
      });
    }
  }

  // Arrows step the body slider.
  const prev = document.querySelector(".service-value-banefit__button.prev");
  const next = document.querySelector(".service-value-banefit__button.next");
  if (prev)
    prev.addEventListener("click", function () {
      body.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      body.next();
    });
});
